import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { CompaniesListTable } from "../components/companies/CompaniesListTable"
import { fetchData } from "../helpers/getData/fetchData"

export const CompaniesList = () => {

  const {t} = useTranslation('global')
  const [companiesList, setCompaniesList] = useState('loading')
  const [reloadData, setReloadData] = useState(false)

  useEffect(() => {
    fetchData(setCompaniesList, '/companies/list', t, 'companies');
  }, [reloadData, t])

  return (
      <Box sx={{ width: '100%', marginTop:'25px' }}>
        {
          companiesList !== 'loading' &&
          <CompaniesListTable rows={companiesList} setReloadData={setReloadData} />
        }
      </Box>
  )
}